export const QUERY_PAYOUT = "QUERY_PAYOUT";
export const QUERY_PAYOUTS = "QUERY_PAYOUTS";
